<template lang="pug">
	div.container-fluid
		.card
			.card-header
				i.mr-2.fa.fa-search
				| Búsqueda
			.card-body
				div.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Agente
							input.form-control.form-control-sm(v-if="permisos.agenda_comercial_consultar_todos", v-model="filtro.usuario", @keypress.enter="buscar")
							input.form-control.form-control-sm(disabled="true", v-if="!permisos.agenda_comercial_consultar_todos", :value="usuario.nombre + ' ' + usuario.apellidos")
						.form-group.mt-2
							label Cliente
							input.form-control.form-control-sm(v-model="filtro.cliente", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Fecha inicio
							.input-group
								datepicker(
									v-model="filtro.fechaIni"
									:monday-first="true"
									:language='$dateLang'
									:bootstrap-styling="true"
									input-class="form-control form-control-sm"
									@closed="buscar"
								)
								.input-group-append
									button.btn.btn-sm.btn-danger(@click="borraFechaIni()")
										span.fa.fa-trash
						.form-group.mt-2
							label Fecha fin
							.input-group
								datepicker(
									v-model="filtro.fechaFin"
									:monday-first="true"
									:language='$dateLang'
									:bootstrap-styling="true"
									input-class="form-control form-control-sm"
									@closed="buscar"
								)
								.input-group-append
									button.btn.btn-sm.btn-danger(@click="borraFechaFin()")
										span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3
						.form-group
							label Tipo de entrada
							br
							.btn-group
								button.btn.btn-sm(:class="(filtro.tipo === null) ? 'btn-primary' : ''", @click="setTipo(null)") Todos
								button.btn.btn-sm(:class="(filtro.tipo === 'gestion') ? 'btn-primary' : ''", @click="setTipo('gestion')") Gestión interna
								button.btn.btn-sm(:class="(filtro.tipo === 'cliente') ? 'btn-primary' : ''", @click="setTipo('cliente')") Contacto cliente
						.form-group(v-if="filtro.tipo !== 'gestion'")
							label Estado
							br
							.btn-group
								button.btn.btn-sm(:class="(filtro.estado === null) ? 'btn-primary' : ''", @click="filtro.estado = null") Todos
								button.btn.btn-sm(:class="(filtro.estado === 'porvenir') ? 'btn-primary' : ''", @click="filtro.estado = 'porvenir'") Por venir
								button.btn.btn-sm(:class="(filtro.estado === 'sinfinalizar') ? 'btn-primary' : ''", @click="filtro.estado = 'sinfinalizar'") Pte. finalizar
								button.btn.btn-sm(:class="(filtro.estado === 'finalizado') ? 'btn-primary' : ''", @click="filtro.estado = 'finalizado'") Finalizado
					.col-xs-12.col-sm-12.col-md-6.col-lg-3.col-xl-3(v-if="filtro.tipo !== 'gestion'")
						.form-group
							label Tipo de contacto
							select.form-control.form-control-sm(v-model="filtro.tipoContacto")
								option(:value="null") Todos
								option(
									v-for="tipo in tiposContacto"
									:key="tipo.ID_tipo"
									:value="tipo.ID_tipo"
								) {{tipo.nombre}}
						.form-group.mt-2
							label Objetivo de contacto
							select.form-control.form-control-sm(v-model="filtro.objetivo")
								option(:value="null") Todos
								option(
									v-for="objetivo in objetivosContacto"
									:key="objetivo.ID_objetivo"
									:value="objetivo.ID_objetivo"
								) {{objetivo.nombre}}
			.card-footer
				button.btn.btn-sm.btn-primary.mr-2(@click="buscar")
					i.fa.fa-search.mr-2
					| Buscar
				button.btn.btn-sm.btn-warning(@click="nuevoRegistro")
					i.fa.fa-edit.mr-2
					| Nueva entrada

		.card.mt-4
			.card-header
				i.fa.fa-list.mr-2
				| Resultados
			.table-responsive
				table.table.table-striped.table-condensed.mb-0
					thead.bg-dark.text-white
						tr
							th Fecha
							th Agente
							th Cliente
							th Tipo contacto
							th Carácter
							th Importe presentado
							th Importe firmado
							th Comentarios
							th
					tbody
						tr(v-for="entrada in listadoEntradas", :key="entrada.ID_entrada", :class="entrada.clase", :style="entrada.estilo")
							td
								span {{new Date(entrada.fecha_inicio_contacto * 1000) | moment('D-M-YYYY H:mm')}}
								div.text-danger(v-if="entrada.cancelada")
									b CANCELADA
							td {{entrada.usuarioNombre}}
							td {{entrada.clienteNombre}}
							td
								| {{entrada.tipoContacto}}
							td {{entrada.objetivo}}
							td
								span(v-if="entrada.importe")
									| {{entrada.importe | currency('€')}}
							td
								span(v-if="entrada.importeFirmado")
									| {{entrada.importeFirmado | currency('€')}}
							td
								span(v-if="entrada.comentarios_finales") {{entrada.comentarios_finales}}
								span(v-else) {{entrada.comentarios_previos}}
							td
								button.btn.btn-sm.btn-primary(@click="editarEntrada(entrada)")
									span.fa.fa-edit

		editor(v-if="editar", :id-registro="editar", @cerrar="$router.push('/main/agenda-comercial/listados')", @saved="buscar")
</template>

<script>
import Editor from '../editor/editor'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
	components: {
		'editor': Editor
	},
	data () {
		return {
			filtro: {
				usuario: '',
				cliente: '',
				fechaIni: new Date(new Date().getTime() - 604800000), // Fecha de inicio una semana antes
				fechaFin: null,
				estado: null,
				tipo: null,
				tipoContacto: null,
				objetivo: null
			},
			tiposContacto: [],
			objetivosContacto: [],
			listado: [],
			editar: null
		}
	},
	watch: {
		'$route.params.id': function (newVal) {
			this.editar = newVal
		}
	},
	created () {
		this.buscar()

		const uri = '/agenda-comercial/php/api/'

		// Obtenemos el listado de tipos de contacto
		axios.get(uri + 'get-listado-tipos.php')
			.then(res => {
				this.tiposContacto = res.data
			})
			.catch(this.apiError)
		// Obtenemos eli listado de objetivos
		axios.get(uri + 'get-listado-objetivos.php')
			.then(res => {
				this.objetivosContacto = res.data
			})
			.catch(this.apiError)

		if (this.$route.params.id) {
			this.editar = this.$route.params.id
		}
	},

	computed: {
		...mapGetters({
			'usuario': 'session/usuario',
			'permisos': 'permisos/permisos'
		}),
		listadoEntradas () {
			return this.listado.map(entrada => {
				entrada.estilo = {}
				entrada.clase = ''

				if (entrada.gestion === 1) {
					entrada.clase = ''
					entrada.estilo = {
						backgroundColor: '#fff716'
					}
				} else {
					if (entrada.cancelada) {
						entrada.clase = 'text-danger'
						entrada.estilo = {}
					} else if (entrada.fecha_fin_contacto < new Date().getTime() / 1000 && !entrada.fecha_cierre_informe) {
						entrada.clase = 'bg-warning'
						entrada.estilo = {}
					}
				}
				return entrada
			})
		}
	},
	methods: {
		nuevoRegistro () {
			this.$router.push('/main/agenda-comercial/listados/nuevo')
		},

		borraFechaIni () {
			this.filtro.fechaIni = null
			this.buscar()
		},

		borraFechaFin () {
			this.filtro.fechaFin = null
			this.buscar()
		},

		setTipo (tipo) {
			this.filtro.tipo = tipo
			if (this.filtro.tipo === 'gestion') {
				this.filtro.tipoContacto = null
				this.filtro.objetivo = null
				this.filtro.estado = null
				this.filtro.estado = null
			}
		},

		buscar () {
			let filtro = JSON.parse(JSON.stringify(this.filtro))

			if (this.filtro.fechaIni) {
				this.filtro.fechaIni.setHours(0)
				this.filtro.fechaIni.setMinutes(0)
				this.filtro.fechaIni.setSeconds(0)
				this.filtro.fechaIni.setMilliseconds(0)
				filtro.fechaIni = (this.filtro.fechaIni) ? Math.round(this.filtro.fechaIni.getTime() / 1000) : null
			}

			if (this.filtro.fechaFin) {
				this.filtro.fechaFin.setHours(23)
				this.filtro.fechaFin.setMinutes(59)
				this.filtro.fechaFin.setSeconds(59)
				this.filtro.fechaFin.setMilliseconds(999)
				filtro.fechaFin = (this.filtro.fechaFin) ? Math.round(this.filtro.fechaFin.getTime() / 1000) : null
			}

			axios.post('/agenda-comercial/php/api/busca-entradas.php', filtro)
				.then(res => {
					this.listado = res.data.entradas
				})
				.catch(this.$responseError)
		},

		editarEntrada (entrada) {
			this.$router.push('/main/agenda-comercial/listados/' + entrada.ID_entrada)
			// this.editar = entrada.ID_entrada
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/listados/listados.vue